export const SORT_LABEL = "activation.widget.topics.sort.label.text";
export const TOPICS_TITLE = "activation.widget.topics.title.text";
export const TOPICS_SUBTITLE = "activation.widget.topics.new.subtitle";
export const CREATE_TOPICS_TITLE = "activation.widget.topics.create.topic.title";
export const CREATE_TOPICS_SUBTITLE = "activation.widget.topics.create.topic.subtitle";

const COLLAPSE_BTN_LABEL = "activation.widget.topics.collapse.btn.text";
const EXPAND_BTN_LABEL = "activation.widget.topics.expand.btn.text";

export const ADD_BTN_TEXT = "activation.widget.topics.btn.add.text";
export const IMPORT_BTN_TITLE = "activation.widget.topics.btn.import.text";
export const IMPORT_BTN_SUBTITLE = "activation.widget.topics.import.subtitle";
export const CREATED_NUM_TEXT = "activation.widget.topics.created.number";
export const MAXIMUM_TOPICS_CREATED_ADD_BTN_TEXT = "activation.topics.max.created.add.btn.text";
const MAXIMUM_TOPICS_CREATED_ADD_EXISTING_BTN_TEXT = "activation.topics.max.created.add.existing.btn.text";

export const KEYWORD_GROUP_ALREADY_USED = "activation.topics.kw.dropdown.already.used.kw.group";
export const KEYWORD_GROUP_APPLY = "common.apply";
export const KEYWORD_GROUP_SEARCH_PLACEHOLDER = "activation.topics.advance.modal.search.placeholder";
export const NOT_AVAILABLE_FILTER = "activation.widget.topics.filter.disabled.tooltip.text";

export const MODAL_TEXTS = {
    titleAdd: "activation.topics.modal.header.add.text",
    titleDelete: "activation.topics.modal.header.remove.text",
    subtitle: "activation.topics.modal.subtitle",
    bodyDelete: "activation.topics.modal.body.delete.new",
    bodyDeleteShared: "activation.topics.modal.body.delete.shared",
    counter: "activation.topics.modal.subtitle.counter",
    buttonCancel: "global.cancel",
    buttonConfirm: "activation.topics.modal.button.confirm",
    buttonRemove: "activation.topics.modal.button.remove.topic",
    buttonDeleteList: "activation.topics.modal.button.delete.list",
    maxCreatedTooltip: "activation.topics.modal.max.created.tooltip",
    maxForOneAddTooltip: "activation.topics.modal.max.for.one.add.tooltip",
    shouldSelectOne: "activation.topics.modal.min.selected.tooltip",
    buttonSelected: "activation.topics.modal.button.selected",
    buttonAdd: "activation.topics.modal.button.add",
    buttonBack: "activation.topics.modal.button.back",
    emptyStateText: "activation.topics.modal.empty.state.text",
};

export const SINGULAR_SUCCESS_TOAST = "activation.topics.toast.success.created.singular";
export const PLURAL_SUCCESS_TOAST = "activation.topics.toast.success.created.plural";

export const DELETE_TOPICS_WITH_KW_TOAST = "activation.topics.toast.success.delete.with.kw";
export const DELETE_TOPICS_WITHOUT_TOAST = "activation.topics.toast.success.delete.without.kw";
